import * as Yup from 'yup';
import i18n from 'i18n';

const schema = Yup.object().shape({
  Password: Yup.string()
    .required(() => i18n.t('common:validation.fieldRequired')),
});
export default schema;

export const schemaPassword = Yup.object().shape({
  NewPassword: Yup.string()
    .min(8, () => i18n.t('auth:validation.passwordChars', { count: 8 }))
    .matches(/[a-z]/, () => i18n.t('auth:validation.passwordLower'))
    .matches(/[A-Z]/, () => i18n.t('auth:validation.passwordUpper'))
    .matches(/[0-9]/, () => i18n.t('auth:validation.passwordNumber')),

  ConfirmNewPassword: Yup.string()
    .oneOf([Yup.ref('$newPassword'), undefined], () => i18n.t('auth:validation.passwordMatch')),
});
